import { blockTypeMessages as messages, toolbarInsertBlockMessages as toolbarMessages } from '@atlaskit/editor-common/messages';
import EditorCodeIcon from '@atlaskit/icon/core/migration/angle-brackets--editor-code';
import EditorInfoIcon from '@atlaskit/icon/core/migration/information--editor-info';
import QuotationMarkIcon from '@atlaskit/icon/core/migration/quotation-mark--quote';
import ExpandIcon from './assets/expand';
export var transformationOptions = function transformationOptions(api, schema) {
  var _api$panel, _api$expand, _api$codeBlock, _api$blockType;
  return [{
    type: schema.nodes.panel,
    title: messages.panel,
    icon: EditorInfoIcon,
    command: api === null || api === void 0 || (_api$panel = api.panel) === null || _api$panel === void 0 ? void 0 : _api$panel.actions.insertPanel
  }, {
    type: schema.nodes.expand,
    title: toolbarMessages.expand,
    icon: ExpandIcon,
    command: api === null || api === void 0 || (_api$expand = api.expand) === null || _api$expand === void 0 ? void 0 : _api$expand.actions.insertExpandWithInputMethod
  }, {
    type: schema.nodes.codeBlock,
    title: messages.codeblock,
    icon: EditorCodeIcon,
    command: api === null || api === void 0 || (_api$codeBlock = api.codeBlock) === null || _api$codeBlock === void 0 ? void 0 : _api$codeBlock.actions.insertCodeBlock
  }, {
    type: schema.nodes.blockquote,
    title: messages.blockquote,
    icon: QuotationMarkIcon,
    command: api === null || api === void 0 || (_api$blockType = api.blockType) === null || _api$blockType === void 0 ? void 0 : _api$blockType.actions.insertBlockQuote
  }];
};